import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from "../../config";

const QuestionImageDisplay = ({ questionId, align = 'center' }) => {
  const [question, setQuestion] = useState(null);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/show_question_image/${questionId}`)  // Adjust this URL based on your API endpoint
      .then(response => {
        setQuestion(response.data);
      })
      .catch(error => {
        console.error('Error fetching question:', error);
      });
  }, [questionId]);

  if (!question || !question.image_url) {
    return null;
  }

return (
<div className={`w-full flex ${align === 'left' ? 'justify-start' : 'justify-center'}`}>
  <div className="inline-block rounded-lg border border-black shadow-md bg-white/5 p-2">
    <img
      src={question.image_url}
      alt="Question"
      className="
        block object-contain
        max-w-[70vw] md:max-w-[55vw] lg:max-w-[40vw]
        h-auto
        md:max-h-[35vh] lg:max-h-[40vh]
        w-auto
      "
    />
  </div>
</div>

);

}

export default QuestionImageDisplay;
